import React, { useState, useEffect, useRef, useCallback } from 'react';
import styled from 'styled-components';
import { MobileWidth, errorColor, pmBlack, pmWhite, pmPurpleLight } from '../sharedData/Constants';
import GeneralContext from '../contexts/GeneralContext';
import {ReactComponent as ErrorIcon}  from '../assets/images/error_icon.svg';

const InputText = (props) => {

    const [inputValue, setInputValue] = useState('');
    const [inputError, setInputError] = useState(false);
	const [touched, setTouched] = useState(false);
	const [isOnFocus, setIsOnFocus] = useState(false);
	const inputRef = useRef(null);

	const onChangeEvents = (event) =>{
		setInputValue(event.target.value);
		handleInputs(event.target);
		if(props.verifyValidForm){
			props.verifyValidForm();
		}
	}

	const onBlurEvents = (event) => {
		setTouched(true);
		handleInputs(event.target);
		setIsOnFocus(false);
	};

	const onFocusEvents = () => {
		setIsOnFocus(true);
	};
	

    const handleTelNumber = (target) => {
        if(target.type === 'tel'){
            const novoNumero = target.value.replace(/\D/g, '');
            setInputValue(novoNumero);
        }
    };

	const handleInputMinimumChars =  useCallback((inputSize, setIsValidInput) => {
		const isValid = inputSize >= 2;
		setInputError(!isValid && touched);
		setIsValidInput(isValid);
	},[touched]);

    const handleInputs = useCallback((target) => {
        const inputName = target.name;
		switch(inputName){
			case 'nome':
				handleInputMinimumChars(target.value.length, (valid) => {props.setIsValidName(valid)});
				break;
			case 'cargo':
				handleInputMinimumChars(target.value.length, (valid) => {props.setIsValidRole(valid)});
				break;
			case 'sobrenome':
				handleInputMinimumChars(target.value.length, (valid) => {props.setIsValidLastName(valid)});
				break;
			case 'empresa':
				handleInputMinimumChars(target.value.length, (valid) => {props.setIsValidCompany(valid)});
				break;
			case 'telefone':
				handleInputMinimumChars(target.value.length,(valid) => {props.setIsValidTel(valid)});
				handleTelNumber(target);
				break;
			case 'email':
				const regexEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
				const validMail = regexEmail.test(target.value);
				setInputError(!validMail && touched);
				props.setIsValidEmail(validMail);
				break;
			default:
				break;	
		}
    },[props,touched, handleInputMinimumChars]);

	useEffect(() => {
		handleInputs(inputRef.current);
	}, [handleInputs]);

    return(
		<GeneralContext.Consumer>
        {data => (
			<StyledInput focus={isOnFocus} name={props.name} theme={data.theme} error={inputError}>
			<StyledLabel focus={isOnFocus} theme={data.theme} error={inputError}>
				{props.label}
			</StyledLabel>
				<input
					theme={data.theme}
					name={props.name}
					error={`${inputError}`}
					focus={`${isOnFocus}`}
					type={props.type}
					value={inputValue}
					onChange={onChangeEvents}
					onBlur={onBlurEvents}
					onFocus={onFocusEvents}
					ref={inputRef}
				/>
				<StyledErrorMessage focus={isOnFocus} theme={data.theme} error={inputError}>
					<ErrorIcon/>
					{props.errorMessage}
				</StyledErrorMessage>           
		   </StyledInput>
   		)}
      </GeneralContext.Consumer>
    );
}

const StyledErrorMessage = styled.div`
	display: ${props => props.focus ? 'none' : props.error  ? 'flex' : 'none' };
	color: ${props => props.theme === 'dark'? pmWhite : pmBlack};
	font-size: 16px;
	gap: 10px;
	margin-top: 12px;
	align-items: center;
	text-align: start;
	@media screen and (max-width: ${MobileWidth}) {
        font-size: 12px;
    }
`;

const StyledLabel = styled.label`
    font-size: 16px;
    color: #ffffff;
    @media screen and (max-width: ${MobileWidth}) {
        font-size: 14px;
    }
`;

const StyledInput = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 5px;
	@media screen and (max-width: ${MobileWidth}) {
		width: 100%;
	}
    input{
        width: 100%;
        height:  5.2vh;
        min-height: 35px;
        border-radius: 10px;
        border: ${props => props.focus ? `2px solid ${pmPurpleLight};` : props.error ? `2px solid ${errorColor};` : props.theme === 'dark'? `2px solid ${pmWhite}` : `2px solid ${pmBlack};`};
        padding: 0px 20px;  
        font-size: 16px;
        max-height: 47px;
        color: ${props => props.focus ? props.theme === 'dark'? pmWhite: pmBlack : props.error ? errorColor : props.theme === 'dark'? pmWhite: pmBlack};
        outline: none;
		background-color: rgba(255, 255, 255, 0.3);
		option{
			background-color:#8A02CA;
		}
    }
`;

export default InputText;